import { create } from 'zustand'
import { Transaction } from './data'
import { retrieveTransactions as apiRetrieveTransactions } from './actions'

interface TransactionStore {
    transactions: Transaction[] | null
    loading: boolean
    error: string | null
    currentClientId: string | null

    // Actions
    retrieveTransactions: (clientId: string, limit?: number) => Promise<void>
    clearTransactions: () => void
    clearError: () => void
    setLoading: (loading: boolean) => void
}

export const useTransactionStore = create<TransactionStore>((set, get) => ({
    transactions: null,
    loading: false,
    error: null,
    currentClientId: null,

    retrieveTransactions: async (clientId: string, limit: number = 50) => {
        const { currentClientId } = get()

        // Don't reload if we already have data for this client
        if (currentClientId === clientId && get().transactions !== null && !get().error) {
            return
        }

        set({
            loading: true,
            error: null,
            currentClientId: clientId
        })

        try {
            const transactions = await apiRetrieveTransactions(clientId, limit)
            set({
                transactions,
                loading: false,
                error: null
            })
        } catch (error: any) {
            set({
                loading: false,
                error: error.message || 'Failed to load transaction history',
                transactions: null
            })
        }
    },

    clearTransactions: () => {
        set({
            transactions: null,
            currentClientId: null,
            error: null
        })
    },

    clearError: () => {
        set({ error: null })
    },

    setLoading: (loading: boolean) => {
        set({ loading })
    }
}))